import React from "react";
import Card from "../../../Shared/Card/Card";
import { BaseIcon } from "@shltelemedicine/shl-ui-lib";
import approveIcon from "../../../../assets/buttons/approve.svg";
import { FormattedMessage } from "react-intl";
import styles from "./ReviewedBanner.module.css";
import { UserRecord } from "../../../../models/ecg.interface";
import DateTime from "../../../Shared/DateTime/DateTime";

type ReviewedBannerProps = {
  reviewerInfo?: UserRecord;
};

const ReviewedBanner = ({ reviewerInfo }: ReviewedBannerProps) => (
  <Card className={`${styles.reviewedCard} font-md container`}>
    <div className="d-flex align-self-center justify-content-center row">
      <div className="col">
        <BaseIcon icon={approveIcon} className={styles.reviewedIcon} />
        <strong className="mx-1">
          <FormattedMessage
            id="ECG_DETAILS.REVIEWED"
            defaultMessage="Reviewed"
          />
        </strong>
      </div>
      <div className="col mx-2 text-nowrap d-flex">
        <strong className={`${styles.divider} px-3`}>
          &nbsp;<DateTime showTime>{reviewerInfo?.date}</DateTime>&nbsp;
          {reviewerInfo?.user.display}
        </strong>
      </div>
    </div>
  </Card>
);

export default ReviewedBanner;
